<template>
  <div class="content">
    <div class="text-box">
      <div class="text-content">
        <p>因我单位性质的特殊性，特委托<span class="highlight">青岛力图数字科技有限公司</span>为我单位网站（<span class="highlight">www.hjbwg.com</span>）开办运营商，主要负责域名注册、网站备案和小程序等业务。此情况已向<span class="highlight">山东省通信管理局</span>上报说明。</p>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: '',
}
</script>

<style lang="less" scoped>
.content {
  padding: 40px;
  font-size: 1.2rem;
  line-height: 1.8;
  text-align: center;
  background: #fff;
  position: relative;
}
.text-box {
  background: #f9f9f9;
  border-left: 5px solid #3498db;
  padding: 30px;
  border-radius: 8px;
  margin: 20px 0;
  box-shadow: 0 4px 10px rgba(0, 0, 0, 0.03);
}
.text-content {
  font-size: 1.3rem;
  line-height: 1.9;
  color: #34495e;
  text-align: justify;
  text-justify: inter-ideograph;
}
.text-content p {
  margin-bottom: 20px;
  text-indent: 2em;
}

</style>